export const FETCH_AUCTION_CENTER = "FETCH_AUCTION_CENTER";
export const FETCH_AUCTION_CENTER_SUCCESS = "FETCH_AUCTION_CENTER_SUCCESS";
export const FETCH_AUCTION_CENTER_FAIL = "FETCH_AUCTION_CENTER_FAIL";


export const GET_PROMPT_DATE_BY_AUCTION_CENTER_REQUEST =
  "GET_PROMPT_DATE_BY_AUCTION_CENTER_REQUEST";
export const GET_PROMPT_DATE_BY_AUCTION_CENTER_SUCCESS =
  "GET_PROMPT_DATE_BY_AUCTION_CENTER_SUCCESS";
export const GET_PROMPT_DATE_BY_AUCTION_CENTER_FAILURE =
  "GET_PROMPT_DATE_BY_AUCTION_CENTER_FAILURE";


  // Fetch prompt dates by auction center
export const FETCH_PROMPT_DATES_BY_AUCTION_CENTER_REQUEST = 'FETCH_PROMPT_DATES_BY_AUCTION_CENTER_REQUEST';
export const FETCH_PROMPT_DATES_BY_AUCTION_CENTER_SUCCESS = 'FETCH_PROMPT_DATES_BY_AUCTION_CENTER_SUCCESS';
export const FETCH_PROMPT_DATES_BY_AUCTION_CENTER_FAILURE = 'FETCH_PROMPT_DATES_BY_AUCTION_CENTER_FAILURE';
